import pencil from 'assets/icons/pencil.svg'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
    getPersonalEmployee,
    patchPersonalEmployee,
} from 'service/PersonalCardService'
import { setPersonalInfo } from 'store/slices/PersonalCard'
import Notification from 'utils/Notifications'
import styles from '../AllStyle.module.scss'

const LocationInfo = () => {
  const { t } = useTranslation('common')
  const [change, setChange] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const [country, setCountry] = useState('')
  const [region, setRegion] = useState('')
  const [village, setVillage] = useState('')
  const [city, setCity] = useState('')
  const [district, setDistrict] = useState('')
  const [street, setStreet] = useState('')
  const [city_district, setCity_district] = useState('')
  const [region_district, setRegion_district] = useState('')

  let data
  const dispatch = useDispatch()
  const [render, setRender] = useState(false)

  const getData = async () => {
    try {
      let response = await getPersonalEmployee(data, 'ru')

      dispatch(
        setPersonalInfo({
          personal_info: response.data,
        }),
      )
    } catch (error) {}
  }

  useEffect(() => {
    getData()
    setRender(false)
  }, [render])

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      let response = await patchPersonalEmployee(
        {
          residence_place: {
            country,
            region,
            village,
            city,
            city_district,
            region_district,
            street,
          },
        },
        'ru',
      )

      setNotify({
        isOpen: true,
        message: t('profile.location.residence_set'),
        type: 'success',
        sound: 'success',
      })

      setRender(true)
      setChange(false)
    } catch (error) {
      setNotify({
        isOpen: true,
        message: t('common.error'),
        type: 'error',
        sound: 'error',
      })
    }
  }

  const info = useSelector((state) => state.personalcard.personal_info)
  const locations = info.residence_place

  return (
    <div className={styles.wrapper}>
      <div style={{ width: '100%', height: '100%' }}>
        {change ? (
          <div className={styles.Design_true}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                <h4 className={styles.header_left_info}>{t('profile.location.title')}</h4>
              </div>
              <div className={styles.headerRight}></div>
            </div>

            <ul className={styles.Design_desc}>
              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.country_colon')}</p>
                <p className={styles.Design_info}>{locations?.country}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.region_colon')}</p>
                <p className={styles.Design_info}>{locations?.region}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.region_district_colon')}</p>
                <p className={styles.Design_info}>
                  {locations?.region_district}
                </p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.city_colon')}</p>
                <p className={styles.Design_info}>{locations?.city}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.village_colon')}</p>
                <p className={styles.Design_info}>{locations?.village}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.city_district_colon')}</p>
                <p className={styles.Design_info}>
                  {locations?.city_district}
                </p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.street_colon')}</p>
                <p className={styles.Design_info}>{locations?.street}</p>
              </li>
            </ul>

            <div className={styles.Design_change_block}>
              <ul className={styles.Design_desc_true}>
                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.location.country')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.location.region')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                    onChange={(e) => setRegion(e.target.value)}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.location.region_district')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                    onChange={(e) => setRegion_district(e.target.value)}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.location.city')}</h3>

                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.location.village')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                    onChange={(e) => setVillage(e.target.value)}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.location.city_district')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                    onChange={(e) => setCity_district(e.target.value)}
                  />
                </li>

                <li className={styles.Design_list_true}>
                  <h3 className={styles.Design_title}>{t('profile.location.street')}</h3>
                  <input
                    type="text"
                    className={styles.Design_info_change_inp}
                    onChange={(e) => setStreet(e.target.value)}
                  />
                </li>
              </ul>
              <div className={styles.change_btn}>
                <button
                  onClick={() => setChange(false)}
                  className={styles.change_btn_Cancel}
                >
                  <p>{t('common.cancel')}</p>
                </button>
                <button
                  onClick={handleSubmit}
                  className={styles.change_btn_save}
                >
                  <p style={{ color: 'white' }}>{t('profile.save_changes')}</p>
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className={styles.Design}>
            <div className={styles.DesignHeader}>
              <div className={styles.header_left}>
                <h4 className={styles.header_left_info}>{t('profile.location.title')}</h4>
              </div>
              <div className={styles.headerRight}>
                <img
                  src={pencil}
                  onClick={() => setChange(true)}
                  className={styles.headerRight_info}
                />
              </div>
            </div>

            <ul className={styles.Design_desc}>
              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.country_colon')}</p>
                <p className={styles.Design_info}>{locations?.country}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.region_colon')}</p>
                <p className={styles.Design_info}>{locations?.region}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.region_district_colon')}</p>
                <p className={styles.Design_info}>
                  {locations?.region_district}
                </p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.city_colon')}</p>
                <p className={styles.Design_info}>{locations?.city}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.village_colon')}</p>
                <p className={styles.Design_info}>{locations?.village}</p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.city_district_colon')}</p>
                <p className={styles.Design_info}>
                  {locations?.city_district}
                </p>
              </li>

              <li className={styles.Design_list}>
                <p className={styles.Design_title}>{t('profile.location.street_colon')}</p>
                <p className={styles.Design_info}>{locations?.street}</p>
              </li>
            </ul>
          </div>
        )}
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
  )
}

export default LocationInfo
